/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebsocketEvent = {
    RECONNECT: 'RECONNECT',
    LEVEL_UP: 'LEVEL_UP',
    DEVOURPLAY_NOTIFICATION: 'DEVOURPLAY_NOTIFICATION',
    REFRESH: 'REFRESH',
    LOGOUT: 'LOGOUT',
    REWARD_DISTRIBUTED: 'REWARD_DISTRIBUTED',
    QUEST_PROGRESSED: 'QUEST_PROGRESSED',
    QUEST_CONFIG_UPDATED: 'QUEST_CONFIG_UPDATED',
    DISCORD_MESSAGE_CREATE: 'DISCORD_MESSAGE_CREATE',
    DISCORD_MESSAGE_UPDATE: 'DISCORD_MESSAGE_UPDATE',
    DISCORD_MESSAGE_DELETE: 'DISCORD_MESSAGE_DELETE',
    DISCORD_INITIAL_MESSAGES: 'DISCORD_INITIAL_MESSAGES',
    DISCORD_ERROR: 'DISCORD_ERROR',
    DISCORD_USER_TYPING: 'DISCORD_USER_TYPING',
    DISCORD_CHANNEL_UPDATE: 'DISCORD_CHANNEL_UPDATE',
    QUEST_REFRESH: 'QUEST_REFRESH',
    INVALIDATE_XP: 'INVALIDATE_XP',
    INVALIDATE_FUEL: 'INVALIDATE_FUEL',
    INVALIDATE_CATEGORY_CONFIG: 'INVALIDATE_CATEGORY_CONFIG',
    TOURNAMENT_BRACKET_UPDATE: 'TOURNAMENT_BRACKET_UPDATE',
    TOURNAMENT_MATCH_READY: 'TOURNAMENT_MATCH_READY',
    TOURNAMENT_STATUS_CHANGED: 'TOURNAMENT_STATUS_CHANGED',
    TOURNAMENT_WAITLIST_PROMOTED: 'TOURNAMENT_WAITLIST_PROMOTED',
    TOURNAMENT_TEAM_DISQUALIFIED: 'TOURNAMENT_TEAM_DISQUALIFIED',
    TOURNAMENT_REGISTRATION_UPDATE: 'TOURNAMENT_REGISTRATION_UPDATE',
    TOURNAMENT_MATCH_SCORE_UPDATE: 'TOURNAMENT_MATCH_SCORE_UPDATE',
    COMPETITION_SCORE_UPDATE: 'COMPETITION_SCORE_UPDATE',
    COMPETITION_RANK_UPDATE: 'COMPETITION_RANK_UPDATE',
    COMPETITION_STATUS_CHANGED: 'COMPETITION_STATUS_CHANGED',
    COMPETITION_SOURCE_REJECTED: 'COMPETITION_SOURCE_REJECTED',
    SCORING_HEALTH_CHANGED: 'SCORING_HEALTH_CHANGED',
    AUTO_SCORING_STATUS_CHANGE: 'AUTO_SCORING_STATUS_CHANGE',
    LADDER_PARTICIPANT_JOINED: 'LADDER_PARTICIPANT_JOINED',
    LADDER_CHALLENGE_ISSUED: 'LADDER_CHALLENGE_ISSUED',
    LADDER_CHALLENGE_ACCEPTED: 'LADDER_CHALLENGE_ACCEPTED',
    LADDER_CHALLENGE_DECLINED: 'LADDER_CHALLENGE_DECLINED',
    LADDER_MATCH_COMPLETED: 'LADDER_MATCH_COMPLETED',
    LADDER_STANDINGS_UPDATED: 'LADDER_STANDINGS_UPDATED',
    LEADERBOARD_PROGRESSED: 'LEADERBOARD_PROGRESSED',
    LEADERBOARD_STANDINGS_UPDATE: 'LEADERBOARD_STANDINGS_UPDATE',
    LEADERBOARD_PRIZE_POOL_UPDATE: 'LEADERBOARD_PRIZE_POOL_UPDATE',
    LEADERBOARD_RESERVATION_DROPPED: 'LEADERBOARD_RESERVATION_DROPPED',
    CHALLENGE_STANDINGS_UPDATE: 'CHALLENGE_STANDINGS_UPDATE',
    SCORE_BOARD_UPDATE: 'SCORE_BOARD_UPDATE',
    FRIEND_REQUEST_RECEIVED: 'FRIEND_REQUEST_RECEIVED',
    FRIEND_REQUEST_ACCEPTED: 'FRIEND_REQUEST_ACCEPTED',
    TEAM_INVITE_RECEIVED: 'TEAM_INVITE_RECEIVED',
    CHAT_MESSAGE_CREATE: 'CHAT_MESSAGE_CREATE',
    CHAT_MESSAGE_UPDATE: 'CHAT_MESSAGE_UPDATE',
    CHAT_MESSAGE_DELETE: 'CHAT_MESSAGE_DELETE',
    CHAT_USER_JOIN: 'CHAT_USER_JOIN',
    CHAT_USER_LEAVE: 'CHAT_USER_LEAVE',
    CHAT_USER_TYPING: 'CHAT_USER_TYPING',
    CHAT_CHANNEL_UPDATE: 'CHAT_CHANNEL_UPDATE',
    CHAT_INITIAL_MESSAGES: 'CHAT_INITIAL_MESSAGES',
    CHAT_ERROR: 'CHAT_ERROR',
    CHALLENGE_INVITE_RECEIVED: 'CHALLENGE_INVITE_RECEIVED',
    CHALLENGE_INVITE_ACCEPTED: 'CHALLENGE_INVITE_ACCEPTED',
    CHALLENGE_INVITE_DECLINED: 'CHALLENGE_INVITE_DECLINED',
    CHALLENGE_STATUS_UPDATE: 'CHALLENGE_STATUS_UPDATE',
    CHALLENGE_STATS_UPDATE: 'CHALLENGE_STATS_UPDATE',
    CHALLENGE_QUEUE_UPDATE: 'CHALLENGE_QUEUE_UPDATE',
    CHALLENGE_TARGET_PROPOSED: 'CHALLENGE_TARGET_PROPOSED',
    CHALLENGE_TARGET_ACCEPTED: 'CHALLENGE_TARGET_ACCEPTED',
    CHALLENGE_TARGET_AGREED: 'CHALLENGE_TARGET_AGREED',
    NOTIFICATION_NEW: 'NOTIFICATION_NEW',
    NOTIFICATION_READ: 'NOTIFICATION_READ',
    NOTIFICATION_DISMISSED: 'NOTIFICATION_DISMISSED',
    NOTIFICATION_COUNT_UPDATE: 'NOTIFICATION_COUNT_UPDATE',
    NOTIFICATIONS_STANDALONE: 'NOTIFICATIONS_STANDALONE',
    FRIEND_ONLINE: 'FRIEND_ONLINE',
    FRIEND_OFFLINE: 'FRIEND_OFFLINE',
    FRIEND_STATUS_UPDATE: 'FRIEND_STATUS_UPDATE',
    DM_MESSAGE_NEW: 'DM_MESSAGE_NEW',
    DM_MESSAGE_READ: 'DM_MESSAGE_READ',
    DM_MESSAGE_DELETED: 'DM_MESSAGE_DELETED',
    DM_USER_TYPING: 'DM_USER_TYPING',
    DM_CONVERSATION_UPDATE: 'DM_CONVERSATION_UPDATE',
    DM_UNREAD_COUNT_UPDATE: 'DM_UNREAD_COUNT_UPDATE',
    ARENA_QUEUE_JOINED: 'ARENA_QUEUE_JOINED',
    ARENA_QUEUE_LEFT: 'ARENA_QUEUE_LEFT',
    ARENA_MATCH_FOUND: 'ARENA_MATCH_FOUND',
    ARENA_QUEUE_EXPIRED: 'ARENA_QUEUE_EXPIRED',
    ARENA_REMATCH_REQUESTED: 'ARENA_REMATCH_REQUESTED',
    ARENA_REMATCH_DECLINED: 'ARENA_REMATCH_DECLINED',
    ACTIVATION_PROGRESSED: 'ACTIVATION_PROGRESSED',
    ACTIVATION_COMPLETED: 'ACTIVATION_COMPLETED',
    ACTIVATION_REWARD_CLAIMED: 'ACTIVATION_REWARD_CLAIMED',
    OPERATION_ACTIVATION_UNLOCKED: 'OPERATION_ACTIVATION_UNLOCKED',
    FEED_EVENT_NEW: 'FEED_EVENT_NEW',
    HUB_PULSE_UPDATE: 'HUB_PULSE_UPDATE',
    STREAK_EXTENDED: 'STREAK_EXTENDED',
    STREAK_BROKEN: 'STREAK_BROKEN',
    STREAK_MILESTONE: 'STREAK_MILESTONE',
    STREAK_WARNING: 'STREAK_WARNING',
    GAMIFICATION_PROGRESS: 'GAMIFICATION_PROGRESS',
    GAMIFICATION_MILESTONE: 'GAMIFICATION_MILESTONE',
    GAMIFICATION_COMPLETED: 'GAMIFICATION_COMPLETED',
    LOOTBOX_OPENED: 'LOOTBOX_OPENED',
    LOOTBOX_DEPLETED: 'LOOTBOX_DEPLETED',
    LOOTBOX_POOL_REFRESHED: 'LOOTBOX_POOL_REFRESHED',
    LOOTBOX_SOLD_OUT_EVICTED: 'LOOTBOX_SOLD_OUT_EVICTED',
    ORDER_STATUS_UPDATE: 'ORDER_STATUS_UPDATE',
    SEASON_TIER_UNLOCKED: 'SEASON_TIER_UNLOCKED',
    HUB_STREAM_LIVE: 'HUB_STREAM_LIVE',
    PREDICTION_OPENED: 'PREDICTION_OPENED',
    PREDICTION_LOCKED: 'PREDICTION_LOCKED',
    PREDICTION_RESOLVED: 'PREDICTION_RESOLVED',
    PREDICTION_POOL_UPDATE: 'PREDICTION_POOL_UPDATE',
    CLIP_FIRE: 'CLIP_FIRE',
    CLIPS_PREF_CHANGED: 'CLIPS_PREF_CHANGED',
    SUPPORT_MESSAGE_CREATE: 'SUPPORT_MESSAGE_CREATE',
    SUPPORT_THREAD_UPDATE: 'SUPPORT_THREAD_UPDATE',
    SUPPORT_ERROR: 'SUPPORT_ERROR',
    LEVEL_GATED: 'LEVEL_GATED'
} as const;
export type WebsocketEvent = typeof WebsocketEvent[keyof typeof WebsocketEvent];


export function instanceOfWebsocketEvent(value: any): boolean {
    for (const key in WebsocketEvent) {
        if (Object.prototype.hasOwnProperty.call(WebsocketEvent, key)) {
            if (WebsocketEvent[key as keyof typeof WebsocketEvent] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WebsocketEventFromJSON(json: any): WebsocketEvent {
    return WebsocketEventFromJSONTyped(json, false);
}

export function WebsocketEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebsocketEvent {
    return json as WebsocketEvent;
}

export function WebsocketEventToJSON(value?: WebsocketEvent | null): any {
    return value as any;
}

export function WebsocketEventToJSONTyped(value: any, ignoreDiscriminator: boolean): WebsocketEvent {
    return value as WebsocketEvent;
}

